import { render } from "./DeliveryReport.vue?vue&type=template&id=4383cc19&scoped=true"
import script from "./DeliveryReport.vue?vue&type=script&lang=js"
export * from "./DeliveryReport.vue?vue&type=script&lang=js"

import "./DeliveryReport.vue?vue&type=style&index=0&id=4383cc19&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4383cc19"]])

export default __exports__